module.exports = __webpack_public_path__ + "static/1-8afe3bc80875f9c08d0a9a5f37fa9cc0.jpg";